import cx from 'classnames';

import { OButton } from '@src/shared';

import { ICalculatorKeypadLayout, ICalculatorHandlers, TCalculatorMode } from '@src/types';

import styles from '../calculator.module.scss';

interface ICalculatorContainerProps {
  layout: ICalculatorKeypadLayout;
  operations: ICalculatorHandlers;
  mode?: TCalculatorMode;
  isReadOnly?: boolean;
}

const CalculatorKeypad = ({ layout, operations, mode, isReadOnly = false }: ICalculatorContainerProps) => {
  return (
    <div
      className={cx(styles.keypad, styles[`keypadCols${layout.cols}`], mode === 'converter' && styles.converterMode, mode === 'scientific' && styles.scientificMode)}
    >
      {layout.buttons.map((button, index) => {
        // Safely handle optional classes
        const classList =
          button.classes
            ?.split(' ')
            .filter(Boolean) // remove empty strings
            .map((cl) => styles[cl]) ?? [];

        return (
          <OButton
            key={index}
            text={button.label}
            disabled={isReadOnly}
            className={cx(styles.button, ...classList, { [styles.readOnly]: isReadOnly })}
            onClick={() => {
              if (!operations[button.onClick] || isReadOnly) return;
              const operation = operations[button.onClick];
              if (operation) {
                // Only handleNumber and handleOperator use the value.
                // AC, ⌫, %, = handlers ignore arguments - passing undefined is fine(they don't have value)
                operation(button.value ?? (typeof button.label === 'string' ? button.label : undefined));
              }
            }}
          />
        );
      })}
    </div>
  );
};

export default CalculatorKeypad;
